import { render, staticRenderFns } from "./BadgeImage.vue?vue&type=template&id=51c7892e&"
import script from "./BadgeImage.vue?vue&type=script&lang=js&"
export * from "./BadgeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports